export default __webpack_public_path__ + "static/media/GW-4000+.73a9a8d8.pdf";